import SeparatorBanner from './SeparatorBanner';

export default SeparatorBanner;